import { forwardRef, MouseEventHandler, ReactNode } from 'react';
import Link from '../Link';
import Stack from '../Stack';
import { styled } from '@mui/material/styles';

export interface BreadcrumbsItemProps {
  icon?: ReactNode;
  onClick?: MouseEventHandler;
  children?: string | ReactNode | ReactNode[];
}

const StyledStack = styled(Stack)(({ theme }) => ({
  ' .MuiSvgIcon-root': {
    fontSize: theme.typography.fontSize,
  },
}));

const BreadcrumbsItem = forwardRef<HTMLDivElement, BreadcrumbsItemProps>(
  ({ icon, onClick, children, ...props }, ref) => {
    return (
      <>
        {onClick ? (
          <Link onClick={onClick} startIcon={icon} {...props}>
            {children}
          </Link>
        ) : (
          <StyledStack ref={ref} direction="row" gap={1} alignItems="center" {...props}>
            {icon}
            <div>{children}</div>
          </StyledStack>
        )}
      </>
    );
  }
);

BreadcrumbsItem.displayName = 'Breadcrumbs.Item';

export default BreadcrumbsItem;
